<script>
export default {
  props: {
    transactionTable: null,
    selectedFundSourceName: null,
    fundSourceBalance: null,
    tableBusy: null,
    selectedFundSource: null,
    isExpired: null,
  },
  data() {
    return {
      fields: [
        {
          key: "date",
          label: "Date",
          tdClass: "align-middle",
        },
        {
          key: "description",
          label: "Description",
          tdClass: "align-middle",
        },
        {
          key: "debit",
          label: "Appropriation",
          tdClass: "align-middle text-end",
          thClass: "text-end",
        },
        {
          key: "credit",
          label: "Allocation",
          tdClass: "align-middle text-end",
          thClass: "text-end",
        },
        {
          key: "balance",
          label: "Unallocated",
          tdClass: "align-middle text-end",
          thClass: "text-end",
        },
      ],
      totalRows: this.transactionTable.length,
      currentPage: 1,
      perPage: 10,
      sortBy: "age",
      sortDesc: false,
      filter: null,
      filterOn: [],
      alert: {
        show: false,
        type: "",
        message: "",
      },
    };
  },
  computed: {
    rows() {
      return this.transactionTable.length;
    },
  },
  watch: {
    transactionTable() {
      this.totalRows = this.transactionTable.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    addTransaction() {
      if (this.isExpired) {
        this.$swal({
          title: "Expired Fund Source",
          text: "This fund source has expired. You cannot add more transactions.",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
        });
        return;
      }
      this.$emit("addTransaction");
    },
    transferFund() {
      if (this.isExpired) {
        this.$swal({
          title: "Expired Fund Source",
          text: "This fund source has expired. You cannot transfer funds anymore.",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
        });
        return;
      }
      this.$emit("transferFund");
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="row w-75">
        <div class="col-md-6">
          <small class="d-block">Fund Source: </small>
          <h4 class="mb-0 text-info">{{ selectedFundSourceName }}</h4>
        </div>
        <div class="col-md-6">
          <small class="d-block">Unallocated Budget: </small>
          <!-- <h4 class="mb-0 text-yellow">{{ formatCurrency(fundSourceBalance) }}</h4> -->
          <h4 class="mb-0 text-yellow">{{ transactionTable.length > 0 ? formatCurrency(transactionTable[0].balance) : formatCurrency(fundSourceBalance) }}</h4>
        </div>
      </div>
      <div class="text-end my-2 w-25">
        <b-dropdown v-if="selectedFundSource"
                    variant="success"
                    size="sm">
          <template slot="button-content">
            Add Transaction
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item @click="addTransaction">
            <i class="bx bx-money font-size-16 align-middle me-2 text-success"></i>
            Add Funds
          </b-dropdown-item>
          <b-dropdown-item @click="transferFund"
                           :disabled="fundSourceBalance < 1 ? true : false">
            <i class="bx bx-transfer font-size-16 align-middle me-2 text-success"></i>
            Transfer Fund</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-right">
        <div id="tickets-table_filter"
             class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"></b-form-input>
          </label>
        </div>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table class="table"
               :items="transactionTable"
               :fields="fields"
               responsive="sm"
               :per-page="perPage"
               :current-page="currentPage"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :filter="filter"
               :filter-included-fields="filterOn"
               @filtered="onFiltered"
               :busy="tableBusy"
               bordered
               outlined
               hover
               striped
               show-empty>
        <template #empty="scope">
          <div class="text-center">
            <h5 class="text-secondary">{{ scope.emptyText }}</h5>
          </div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(debit)="row">
          <span class="text-light">{{ formatCurrency(row.item.debit) }}</span>
        </template>
        <template #cell(balance)="row">
          <span v-if="row.item.balance < 0"
                class="text-danger">({{ formatCurrency(row.item.balance) }})</span>
          <span v-else>{{ formatCurrency(row.item.balance) }}</span>
        </template>
        <template #cell(credit)="row">
          <span class="text-light">{{ formatCurrency(row.item.credit) }}</span>
        </template>
        <template #cell(date)="row">
          <span>{{
            new Date(row.item.date).toLocaleDateString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })
          }}</span>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
